import { useAppSelector } from "@redux/hooks";
import {
  selectClaimDetails,
  selectClaimDetailsType,
  selectLossType,
} from "@redux/slices";

export function useGetClaimDetailsForLossType() {
  const lossType = useAppSelector(selectLossType);
  const claimDetails = useAppSelector(selectClaimDetails);
  const claimDetailsType = useAppSelector(selectClaimDetailsType);
  return lossType === claimDetailsType ? claimDetails : undefined;
}
